import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "#00427A",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.513 4.19505L10.237 6.99805H1.48V8.99805H10.237L7.513 11.8L8.948 13.195L13.998 7.99805L8.948 2.80005L7.513 4.19505Z"
	})]
});
const ForwardRef = forwardRef(SvgArrowRightSmall);
export { ForwardRef as ReactComponent };
